// This module provides API call methods for Sephora Commerce Utility APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Utility+APIs

const storeLocator = require('services/api/utility/storeLocator');
const getAboutMeReviewQuestions = require('services/api/utility/getAboutMeReviewQuestions');
const getAdvocacyLandingPageContent = require('services/api/utility/getAdvocacyLandingPageContent');
const enrollCampaign = require('services/api/utility/enrollCampaign');
const updatePreviewSettings = require('services/api/utility/updatePreviewSettings');
const getPreviewSettings = require('services/api/utility/getPreviewSettings');
const getCountryList = require('services/api/utility/getCountryList');
const getShippingCountryList = require('services/api/utility/getShippingCountryList');
const getSubscriptionCancelReasons = require('services/api/utility/getSubscriptionCancelReasons');
const getGiftCardBalance = require('services/api/utility/getGiftCardBalance');
const getStateAndCityForZipCode = require('services/api/utility/getStateAndCityForZipCode');
const getStateList = require('services/api/utility/getStateList');
const getLocation = require('services/api/utility/getLocation');
const contactUs = require('services/api/utility/contactUs/contactUs');
const resetSessionExpiry = require('services/api/utility/resetSessionExpiry');
const validateAddress = require('services/api/utility/validateAddress');
const isUserEligible = require('services/api/utility/isUserEligible');

const {
    requestEmailNotificationForOutOfStockSku,
    requestEmailNotificationForComingSoonSku,
    cancelEmailNotificationRequest
} = require('services/api/utility/requestEmailNotification');

module.exports = {
    storeLocator,
    getAboutMeReviewQuestions,
    enrollCampaign,
    getAdvocacyLandingPageContent,
    updatePreviewSettings,
    getPreviewSettings,
    getCountryList,
    getShippingCountryList,
    getSubscriptionCancelReasons,
    getGiftCardBalance,
    getStateAndCityForZipCode,
    getStateList,
    requestEmailNotificationForOutOfStockSku,
    requestEmailNotificationForComingSoonSku,
    cancelEmailNotificationRequest,
    getLocation,
    contactUs,
    resetSessionExpiry,
    validateAddress,
    isUserEligible
};
